import React from 'react'
const FlightInfoTerminator = (props) => {
    var moment = require('moment');

    let { selectedFlightInfo, direction } = props   
    if(direction === '2')
        {

        let flightNumber =  selectedFlightInfo.FltNumOutbound;
        let departTime = moment(selectedFlightInfo.ETA_Outbound).format('HH:mm')
        //For others, only outbound
        return (

            <div className="fullWidth">
                <div className="flightNumberDisplay">
                    <div className="flightCode">{selectedFlightInfo.IATAMarketingcodeOutbound}</div>
                    <div className="flightNumber" >{flightNumber} <span className="tailNumber">/ {props.selectedFlightInfo.UncorrectedTailNum}</span></div>
                </div>
                <div className="cityTime">{props.selectedFlightInfo.DepAirportOutbound} - {props.selectedFlightInfo.ArrAirportOutbound} / {departTime} </div>
                <div className="clear"></div>
            </div>
        )
    }
}

export default FlightInfoTerminator